import { Component, signal } from '@angular/core';

import { Subject, of } from 'rxjs';

import {
  AddressFormComponent,
  ContactProfileCardComponent,
  ContactProfileComponent,
  DateTimeRangeEditorComponent,
  DocumentsComponent,
  FilterContainerComponent,
  FilterDisplayerComponent,
  FiltersComponent,
  FiltersContainerComponent,
  FiltersFormComponent,
  FiltersTagComponent,
  PanelFormLayoutComponent,
  SearchDisplayerComponent,
  SearchHistoryDisplayerComponent,
  TextToClipboardComponent,
} from '@camelot/core';
import { CamContactService } from '@camelot/services';
import { RequestState } from '@camelot/utils';

import { TestIdDirective } from '@camelot/testing-harness';

const contactMock = {
  firstName: 'Jane',
  id: 'contact-1',
  lastName: 'Doe',
  mail: 'jane@example.com',
  phoneNumber: '+3210000000',
};

const contactServiceMock = {
  fetchContactById$: () => of(contactMock),
  fetchDynamicProps$: () => of(contactMock),
  fetchSearchContact$: () => of([contactMock]),
};

@Component({
    imports: [
        AddressFormComponent,
        ContactProfileCardComponent,
        ContactProfileComponent,
        DateTimeRangeEditorComponent,
        DocumentsComponent,
        FilterContainerComponent,
        FilterDisplayerComponent,
        FiltersComponent,
        FiltersContainerComponent,
        FiltersFormComponent,
        FiltersTagComponent,
        PanelFormLayoutComponent,
        SearchDisplayerComponent,
        SearchHistoryDisplayerComponent,
        TestIdDirective,
        TextToClipboardComponent,
    ],
    providers: [{ provide: CamContactService, useValue: contactServiceMock }],
    template: `
    <cam-filters camTestId="cam-filters">filters</cam-filters>
    <cam-filters-container camTestId="cam-filters-container">filters container</cam-filters-container>
    <cam-filter-container camTestId="cam-filter-container">filter container</cam-filter-container>
    <cam-filter-displayer camTestId="cam-filter-displayer">filter displayer</cam-filter-displayer>
    <cam-filters-form camTestId="cam-filters-form">filters form</cam-filters-form>
    <cam-filters-tag camTestId="cam-filters-tag">tag</cam-filters-tag>
    <cam-search-displayer camTestId="cam-search-displayer">search</cam-search-displayer>
    <cam-search-history-displayer camTestId="cam-search-history-displayer" />
    <cam-date-time-range-editor
      camTestId="cam-date-time-range-editor"
      [startDate]="this.startDate"
      [endDate]="this.endDate"
    />
    <cam-text-to-clipboard camTestId="cam-text-to-clipboard" value="copy me" />
    <cam-panel-form-layout
      camTestId="cam-panel-form-layout"
      [askValidation$]="this.askValidation$"
      [formValidity]="this.formValidity"
      [parentRequestState]="this.requestStateInstance"
    >
      panel form content
    </cam-panel-form-layout>
    <cam-documents camTestId="cam-documents" [document$]="this.documents$" [canAddFile]="false" />
    <cam-contact-profile camTestId="cam-contact-profile" [contact]="this.contact" />
    <cam-contact-profile-card camTestId="cam-contact-profile-card" contactId="contact-1" />
    <cam-address-form camTestId="cam-address-form" [askValidation$]="this.askValidation$" />
  `
})
export class CoreRootCase {
  public askValidation$ = new Subject<null>();
  public contact = contactMock;
  public documents$ = of([]);
  public endDate = '2026-01-02T10:00:00Z';
  public formValidity = signal(true);
  public requestStateInstance = new RequestState();
  public startDate = '2026-01-01T10:00:00Z';
}
